module.exports = __webpack_public_path__ + "static/img/rw.240b3961.svg";